import GlobalStyles from "styles/GlobalStyles";
import { css } from "styled-components/macro"; //eslint-disable-line

/* Inner Pages */
import { Home, BlogIndex, Diet } from "pages";
import { Login, Signup } from "pages/auth";
import { AboutUs, ContactUs, TermsOfService, PrivacyPolicy } from "pages/misc";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { DietDetail } from "pages/Diet";

// Layouts
import { Layout as DietLayout } from "components/diet";
import { useSelector } from "react-redux";
import Refund from "pages/misc/Refund";

const GuestRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to={"/diets"} />;
  }

  return children;
};

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={"/auth/sign-in"} />;
  }

  return children;
};

export default function App() {
  return (
    <>
      <GlobalStyles />
      <Router>
        <Routes>
          <Route
            path="/diets/*"
            element={
              <ProtectedRoute>
                <DietLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Diet />} />
            <Route path=":id" element={<DietDetail />} />
          </Route>

          <Route path="/blog" element={<BlogIndex />} />

          <Route
            path="/auth/*"
            element={
              <GuestRoute>
                <Routes>
                  <Route path="sign-in" element={<Login />} />
                  <Route path="sign-up" element={<Signup />} />
                </Routes>
              </GuestRoute>
            }
          />

          <Route path="/" element={<Home />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="contact" element={<ContactUs />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms" element={<TermsOfService />} />
          <Route path="refund-policy" element={<Refund />} />
        </Routes>
      </Router>
    </>
  );
}
